import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

var firebaseConfig = {
    apiKey: "AIzaSyDNoLHk8Ah-_MlRW5ejeo1_gxS3GfMGWzk",
    authDomain: "bedrock-trading.firebaseapp.com",
    databaseURL: "https://bedrock-trading.firebaseio.com",
    projectId: "bedrock-trading",
    storageBucket: "bedrock-trading.appspot.com",
    messagingSenderId: "356902058802",
    appId: "1:356902058802:web:9bf84026e8bd8c61c6352b",
    measurementId: "G-E7FG13R52X"
};

firebase.initializeApp(firebaseConfig);

// firebase.firestore().settings({ timestampsInSnapshots: true });

export default firebase;